module.exports = function () {
    var $ = require('jquery');

    var header = {
        setDropdownHeights: function () {
            //Set Dropdowns height
            var $newHeight = $('html').height() - $('.header').height();
            // $('.dropdown-menu.sub-menu').css('height', $newHeight + 'px');

            //Position search vertically centered
            var $searchHeight = $('.full-search-box').height();
            var $searchMargin = ( ( ( $(window).height() - $('.header').height() ) / 2 ) - ( $searchHeight / 2 ) ) / 2;
            $('.full-search-box').css('margin-top', $searchMargin);
        },
        updateTrendingTopics: function() {
            var $newsAnalysis = $('.navbar-header:visible .NewsAnalysis .dropdown-menu');
            var $trendingTopics = $('.navbar-header:visible .TrendingTopics');
            $newsAnalysis.append('<li></li>');

            $trendingTopics.find('.dropdown-toggle').removeClass('dropdown-toggle').addClass('list-subheader');
            $trendingTopics.find('.dropdown-menu').removeClass('dropdown-menu').addClass('list-unstyled');

            $newsAnalysis.find('li:last-child').append($trendingTopics.html());
            $trendingTopics.remove();
        },
        closeOpenMenus: function() {

            $('.navbar-btn .open .topmenu-title').each( function () {
                $(this).html($(this).data('title'));
            });

            $('.navbar-btn .open').each( function () {
                $(this).next('.dropdown-menu').fadeToggle(500);
                $(this).removeClass('open');
            });

        }
    };

    //Set Dropdowns height
    $(document).ready(function () {
        header.setDropdownHeights();
        header.updateTrendingTopics();
    });
    $(window).on('resize', function () {
        header.setDropdownHeights();
    });

    $('.navbar-btn > li > .dropdown-toggle').on("click", function (e) {
        e.preventDefault(); //To prevent href

        /**
         * This will add and remove relative classes (open) for styling and functionality purposes
         * @type {any}
         */
        var $this = $(this),
            $target = $this.next('ul'),
            $toggleMenu = $('.dropdown-toggle.open'),
            $openMenu = $('.dropdown-menu.sub-menu.open');

        header.closeOpenMenus();

        if ($target && !$target.is($openMenu)) {
            $this.next('.dropdown-menu').fadeToggle(250);
            $target.addClass('open');
            $this.addClass('open');
            // $this.find('.topmenu-title').html('Close');
            $openMenu.parent().removeClass('open');
            $openMenu.parent().find('.topmenu-title').html($openMenu.parent().find('.topmenu-title').data('title'));
            $this.parent().addClass('open');
        }
    });

    /**
     * Apply bootstrap backdrop to our custom modal fullscreen class
     * @type {any}
     */
    var $modal_fullscreen = $(".modal-fullscreen");
    $modal_fullscreen.on('show.bs.modal', function () {
        setTimeout(function () {
            $(".modal-backdrop").addClass("modal-backdrop-fullscreen");
        }, 0);
    });
    $modal_fullscreen.on('hidden.bs.modal', function () {
        $(".modal-backdrop").addClass("modal-backdrop-fullscreen");
    });

    /**
     * Stop modal login button to redirect
     */
    $('a.open-modal-fullscreen').on('click', function (e) {
        e.preventDefault();
        $('#login-fullscreen').modal('show');
    });

};
